import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  Legend,
  CartesianGrid,
  LabelList, // ✅ add this
} from "recharts";

import statisticApi from "../../api/statistic/statisticApi";
import { useSelector } from "react-redux";

const MonthlyAppointmentsLineChart = ({ bookings = [] }) => {
  const today = moment().startOf("day");
  const [stats, setStats] = useState(null);
  const operator = useSelector((state) => state.user?.user); // adjust to your slice

  console.log({ operator });

  useEffect(() => {
    const fetchStats = async () => {
      const { response, err } = await statisticApi.getBookingStats(
        operator?._id,
      );
      if (response) setStats(response.data);
      if (err) console.error("Stats fetch failed:", err);
    };
    fetchStats();
  }, []);

  console.log({ stats });

  const chartData = useMemo(() => {
    const days = [];

    for (let i = 29; i >= 0; i--) {
      const day = today.clone().subtract(i, "days");
      days.push({
        name: day.format("MMM D"), // e.g. Apr 1
        date: day.format("YYYY-MM-DD"),
        Appointments: 0,
      });
    }

    bookings.forEach((booking) => {
      const dateStr = moment(
        booking.selectedDateTime,
        "YYYY-MM-DD hh:mm A",
      ).format("YYYY-MM-DD");
      const match = days.find((d) => d.date === dateStr);
      if (match) match.Appointments += 1;
    });

    return days;
  }, [bookings]);

  const totalAppointments = chartData.reduce(
    (sum, d) => sum + d.Appointments,
    0,
  );

  return (
    <div className="bg-drylight dark:bg-neutral-800 p-5 rounded-xl border border-border">
      <h2 className="text-lg font-semibold text-yellowdark mb-1">
        Appointments
      </h2>
      <p className="text-xs text-text mb-3">Last 30 days</p>

      <h1 className="text-3xl font-bold text-yellowlight mb-2">
        {totalAppointments} booked
      </h1>
      {/* <div className="mt-6 shadow">
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={chartData}>
            <XAxis
              dataKey="name"
              tick={{ fontSize: 10 }}
              interval={3}
              stroke="#fed693"
            />
            <YAxis allowDecimals={false} stroke="#fed693" />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="Appointments"
              stroke="#fed693"
              strokeWidth={2}
              dot={{ r: 3 }}
              activeDot={{ r: 6 }}
            />
          </LineChart>
        </ResponsiveContainer>
        <div className="flex items-center gap-4 mt-4 text-sm text-textGray">
          <div className="flex items-center gap-1">
            <span className="w-3 h-3 bg-yellowlight rounded-full" />
            Appointments
          </div>
        </div>
      </div> */}
      <div className="mt-6 shadow">
        <ResponsiveContainer width="100%" height={240}>
          <LineChart
            data={chartData}
            margin={{ top: 25, right: 20, bottom: 5, left: 0 }}
          >
            <XAxis
              dataKey="name"
              tick={{ fontSize: 10 }}
              interval={3}
              stroke="#fed693"
            />

            <YAxis
              allowDecimals={false}
              stroke="#fed693"
              domain={[0, (dataMax) => dataMax + 1]}
            />

            <Tooltip />

            <Line
              type="monotone"
              dataKey="Appointments"
              stroke="#ca7100"
              strokeWidth={2}
              dot={{ r: 3 }}
              activeDot={{ r: 6 }}
            >
              <LabelList
                dataKey="Appointments"
                position="top"
                offset={10}
                fill="#fed693"
                fontSize={11}
                fontWeight={600}
                formatter={(value) => (value > 0 ? value : "")}
              />
            </Line>
          </LineChart>
        </ResponsiveContainer>

        <div className="flex items-center gap-4 mt-4 text-sm text-textGray">
          <div className="flex items-center gap-1">
            <span className="w-3 h-3 bg-yellowlight rounded-full" />
            Appointments
          </div>
        </div>
      </div>
      {/* 🔹 New Stats Overview */}

      {stats && (
        <div className="bg-drylight dark:bg-neutral-800 py-5 rounded-xl ">
          <h2 className="text-lg font-semibold text-yellowdark mb-4">
            Booking Statistics
          </h2>
          <div className="mt-10">
            <ResponsiveContainer width="100%" height={350}>
              <BarChart
                data={stats.bookingsByMonth}
                margin={{ top: 25, right: 15, bottom: 5, left: 0 }}
              >
                <CartesianGrid strokeDasharray="1 3" stroke="#444" />
                <XAxis
                  dataKey={(d) => {
                    const monthNames = [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ];
                    return monthNames[d._id.month - 1]; // month is 1-based
                  }}
                  stroke="#fed693"
                />
                <YAxis
                  stroke="#fed693"
                  allowDecimals={false}
                  domain={[0, (dataMax) => dataMax + 10]} // extra 20 units above tallest bar
                />
                <Tooltip />

                <Bar
                  dataKey="count"
                  fill="#fed693"
                  barSize={35}
                  radius={[6, 6, 0, 0]}
                >
                  {/* 🔑 Show count above each bar */}
                  <LabelList
                    dataKey="count"
                    position="top"
                    offset={5} // moves text up by 10px
                    fill="#fff"
                    fontSize={12}
                    formatter={(value) => (value === 0 ? "" : value)}
                  />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
          {/* Key numbers */}
          <hr className="w-40 bg-border border border-yellowdark h-[1px] my-4 mx-auto" />
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
            <div>
              <p className="text-sm text-textGray">Total</p>
              <p className="text-xl font-bold text-yellowlight">
                {stats.totalBookings}
              </p>
            </div>
            <div>
              <p className="text-sm text-textGray">Last Month</p>
              <p className="text-xl font-bold text-yellowlight">
                {stats.bookingsLastMonth}
              </p>
            </div>

            <div>
              <p className="text-sm text-textGray">Last 7 days</p>
              <p className="text-xl font-bold text-yellowlight">
                {stats.bookingsLastWeek}
              </p>
            </div>
            <div>
              <p className="text-sm text-textGray">Today</p>
              <p className="text-xl font-bold text-yellowlight">
                {stats.bookingsToday}
              </p>
            </div>
          </div>

          {/* Bar chart of monthly stats */}
        </div>
      )}
    </div>
  );
};

export default MonthlyAppointmentsLineChart;
